import { Validator } from '@vista-digital/validator';
import { InvalidFieldNameError } from '../../../types/invalid-field-name-error';
import { captchaFieldDisplayTextValidator, defaultCaptchaFieldDisplayText } from '../../form/field/captcha/types/display-text';
import { checkboxFieldDisplayTextValidator } from '../../form/field/checkbox/types/display-text';
import { dateFieldDisplayTextValidator } from '../../form/field/date/types/display-text';
import { dropdownFieldDisplayTextValidator } from '../../form/field/dropdown/types/display-text';
import { inputFieldDisplayTextValidator } from '../../form/field/input/types/display-text';
import { defaultMemberFormDateOfBirthFieldConfig, memberFormDateOfBirthFieldConfigValidator } from './config/date-of-birth-field';
import { defaultMemberFormGenderFieldConfig, memberFormGenderFieldConfigValidator } from './config/gender-field';
import { defaultMemberFormPrimarySiteFieldConfig, memberFormPrimarySiteFieldConfigValidator } from './config/primary-site-field';
import { defaultMemberFormAddressFieldDisplayText, defaultMemberFormAllowThirdPartyContactFieldDisplayText, defaultMemberFormAllowThirdPartyProfilingFieldDisplayText, defaultMemberFormCityFieldDisplayText, defaultMemberFormDateOfBirthFieldDisplayText, defaultMemberFormExternalIdFieldDisplayText, defaultMemberFormFamilyNameFieldDisplayText, defaultMemberFormFavouriteGenresFieldDisplayText, defaultMemberFormGenderFieldDisplayText, defaultMemberFormGivenNameFieldDisplayText, defaultMemberFormHomeNumberFieldDisplayText, defaultMemberFormMobileNumberFieldDisplayText, defaultMemberFormNationalIdFieldDisplayText, defaultMemberFormNewsletterFieldDisplayText, defaultMemberFormPostCodeFieldDisplayText, defaultMemberFormPrimarySiteFieldDisplayText, defaultMemberFormStateFieldDisplayText, defaultMemberFormSuburbFieldDisplayText, defaultMemberFormTermsAndConditionsFieldDisplayText, memberFormGenderFieldDisplayTextValidator } from './display-text';
import { MemberFormFieldName } from './name';
export const memberFormFieldPropsBaseValidatorSchema = {
    readonly: Validator.optional(Validator.boolean()),
    enableValidatingIndicator: Validator.optional(Validator.boolean()),
    validatingIconName: Validator.optional(Validator.nonEmptyString),
    classBuilder: Validator.optional(Validator.object({ block: Validator.fn(), element: Validator.fn() }))
};
const memberFormInputFieldName = [
    MemberFormFieldName.GivenName,
    MemberFormFieldName.FamilyName,
    MemberFormFieldName.MobileNumber,
    MemberFormFieldName.HomeNumber,
    MemberFormFieldName.NationalId,
    MemberFormFieldName.ExternalId,
    MemberFormFieldName.Address,
    MemberFormFieldName.Suburb,
    MemberFormFieldName.City,
    MemberFormFieldName.State,
    MemberFormFieldName.PostCode
];
const memberFormInputFieldPropsValidator = Validator.object(Object.assign(Object.assign({}, memberFormFieldPropsBaseValidatorSchema), { name: Validator.oneOf(memberFormInputFieldName), displayText: inputFieldDisplayTextValidator }));
const memberFormCheckboxFieldName = [
    MemberFormFieldName.Newsletter,
    MemberFormFieldName.TermsAndConditions,
    MemberFormFieldName.AllowThirdPartyContact,
    MemberFormFieldName.AllowThirdPartyProfiling
];
const memberFormCheckboxFieldPropsValidator = Validator.object(Object.assign(Object.assign({}, memberFormFieldPropsBaseValidatorSchema), { name: Validator.oneOf(memberFormCheckboxFieldName), checkedValue: Validator.optional(Validator.boolean()), displayText: checkboxFieldDisplayTextValidator }));
const memberFormFavouriteGenresFieldPropsValidator = Validator.object(Object.assign(Object.assign({}, memberFormFieldPropsBaseValidatorSchema), { name: Validator.isEqualTo(MemberFormFieldName.FavouriteGenres), displayText: checkboxFieldDisplayTextValidator }));
const memberFormDateOfBirthFieldPropsValidator = Validator.object(Object.assign(Object.assign({}, memberFormFieldPropsBaseValidatorSchema), { name: Validator.isEqualTo(MemberFormFieldName.DateOfBirth), config: memberFormDateOfBirthFieldConfigValidator, displayText: dateFieldDisplayTextValidator }));
const memberFormPrimarySiteFieldPropsValidator = Validator.object(Object.assign(Object.assign({}, memberFormFieldPropsBaseValidatorSchema), { name: Validator.isEqualTo(MemberFormFieldName.PrimarySite), config: memberFormPrimarySiteFieldConfigValidator, displayText: dropdownFieldDisplayTextValidator }));
const memberFormGenderFieldPropsValidator = Validator.object(Object.assign(Object.assign({}, memberFormFieldPropsBaseValidatorSchema), { name: Validator.isEqualTo(MemberFormFieldName.Gender), config: memberFormGenderFieldConfigValidator, displayText: memberFormGenderFieldDisplayTextValidator }));
const memberFormCaptchaFieldPropsValidator = Validator.object(Object.assign(Object.assign({}, memberFormFieldPropsBaseValidatorSchema), { name: Validator.isEqualTo(MemberFormFieldName.Captcha), displayText: captchaFieldDisplayTextValidator }));
export const memberFormFieldPropsValidatorList = [
    memberFormInputFieldPropsValidator,
    memberFormCheckboxFieldPropsValidator,
    memberFormFavouriteGenresFieldPropsValidator,
    memberFormDateOfBirthFieldPropsValidator,
    memberFormPrimarySiteFieldPropsValidator,
    memberFormGenderFieldPropsValidator,
    memberFormCaptchaFieldPropsValidator
];
export const memberFormFieldPropsValidator = Validator.any(memberFormFieldPropsValidatorList);
const defaultAddressFieldProps = {
    name: MemberFormFieldName.Address,
    displayText: defaultMemberFormAddressFieldDisplayText
};
const defaultCityFieldProps = {
    name: MemberFormFieldName.City,
    displayText: defaultMemberFormCityFieldDisplayText
};
const getDefaultDateOfBirthFieldProps = () => ({
    name: MemberFormFieldName.DateOfBirth,
    config: defaultMemberFormDateOfBirthFieldConfig,
    displayText: defaultMemberFormDateOfBirthFieldDisplayText
});
const defaultExternalIdFieldProps = {
    name: MemberFormFieldName.ExternalId,
    displayText: defaultMemberFormExternalIdFieldDisplayText
};
const defaultFamilyNameFieldProps = {
    name: MemberFormFieldName.FamilyName,
    displayText: defaultMemberFormFamilyNameFieldDisplayText
};
const defaultPrimarySiteFieldProps = {
    name: MemberFormFieldName.PrimarySite,
    config: defaultMemberFormPrimarySiteFieldConfig,
    displayText: defaultMemberFormPrimarySiteFieldDisplayText
};
const defaultFavouriteGenresFieldProps = {
    name: MemberFormFieldName.FavouriteGenres,
    displayText: defaultMemberFormFavouriteGenresFieldDisplayText
};
const defaultGenderFieldProps = {
    name: MemberFormFieldName.Gender,
    config: defaultMemberFormGenderFieldConfig,
    displayText: defaultMemberFormGenderFieldDisplayText
};
const defaultGivenNameFieldProps = {
    name: MemberFormFieldName.GivenName,
    displayText: defaultMemberFormGivenNameFieldDisplayText
};
const defaultHomeNumberFieldProps = {
    name: MemberFormFieldName.HomeNumber,
    displayText: defaultMemberFormHomeNumberFieldDisplayText
};
const defaultMobileNumberFieldProps = {
    name: MemberFormFieldName.MobileNumber,
    displayText: defaultMemberFormMobileNumberFieldDisplayText
};
const defaultNationalIdFieldProps = {
    name: MemberFormFieldName.NationalId,
    displayText: defaultMemberFormNationalIdFieldDisplayText
};
const defaultNewsletterFieldProps = {
    name: MemberFormFieldName.Newsletter,
    displayText: defaultMemberFormNewsletterFieldDisplayText
};
const defaultPostCodeFieldProps = {
    name: MemberFormFieldName.PostCode,
    displayText: defaultMemberFormPostCodeFieldDisplayText
};
const defaultCaptchaFieldProps = {
    name: MemberFormFieldName.Captcha,
    displayText: defaultCaptchaFieldDisplayText
};
const defaultStateFieldProps = {
    name: MemberFormFieldName.State,
    displayText: defaultMemberFormStateFieldDisplayText
};
const defaultSuburbFieldProps = {
    name: MemberFormFieldName.Suburb,
    displayText: defaultMemberFormSuburbFieldDisplayText
};
const defaultTermsAndConditionsFieldProps = {
    name: MemberFormFieldName.TermsAndConditions,
    displayText: defaultMemberFormTermsAndConditionsFieldDisplayText
};
const defaultAllowThirdPartyProfilingFieldProps = {
    name: MemberFormFieldName.AllowThirdPartyProfiling,
    displayText: defaultMemberFormAllowThirdPartyProfilingFieldDisplayText
};
const defaultAllowThirdPartyContactFieldProps = {
    name: MemberFormFieldName.AllowThirdPartyContact,
    displayText: defaultMemberFormAllowThirdPartyContactFieldDisplayText
};
export const defaultMemberFormFieldPropsProvider = (props, componentName) => {
    switch (props.name) {
        case MemberFormFieldName.Address:
            return defaultAddressFieldProps;
        case MemberFormFieldName.City:
            return defaultCityFieldProps;
        case MemberFormFieldName.DateOfBirth:
            return getDefaultDateOfBirthFieldProps();
        case MemberFormFieldName.ExternalId:
            return defaultExternalIdFieldProps;
        case MemberFormFieldName.FamilyName:
            return defaultFamilyNameFieldProps;
        case MemberFormFieldName.PrimarySite:
            return defaultPrimarySiteFieldProps;
        case MemberFormFieldName.FavouriteGenres:
            return defaultFavouriteGenresFieldProps;
        case MemberFormFieldName.Gender:
            return defaultGenderFieldProps;
        case MemberFormFieldName.GivenName:
            return defaultGivenNameFieldProps;
        case MemberFormFieldName.HomeNumber:
            return defaultHomeNumberFieldProps;
        case MemberFormFieldName.MobileNumber:
            return defaultMobileNumberFieldProps;
        case MemberFormFieldName.NationalId:
            return defaultNationalIdFieldProps;
        case MemberFormFieldName.Newsletter:
            return defaultNewsletterFieldProps;
        case MemberFormFieldName.PostCode:
            return defaultPostCodeFieldProps;
        case MemberFormFieldName.Captcha:
            return defaultCaptchaFieldProps;
        case MemberFormFieldName.State:
            return defaultStateFieldProps;
        case MemberFormFieldName.Suburb:
            return defaultSuburbFieldProps;
        case MemberFormFieldName.TermsAndConditions:
            return defaultTermsAndConditionsFieldProps;
        case MemberFormFieldName.AllowThirdPartyProfiling:
            return defaultAllowThirdPartyProfilingFieldProps;
        case MemberFormFieldName.AllowThirdPartyContact:
            return defaultAllowThirdPartyContactFieldProps;
        default:
            throw new InvalidFieldNameError(componentName, props.name);
    }
};
export const isInputFieldProps = (props) => {
    return memberFormInputFieldName.includes(props.name);
};
export const isCheckboxFieldProps = (props) => {
    return memberFormCheckboxFieldName.includes(props.name);
};
//# sourceMappingURL=props.js.map